import {
  ArrowLeftCircle,
  InfoEmpty,
  MoreHorizCircle,
  Star,
  Trash,
} from 'iconoir-react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AlertDialog from '../../components/common/AlertDialog'
import {
  EmptyText,
  RichText,
  SingleLineEllipsis,
} from '../../components/common/CellText'
import { DislikeFilled, LikeFilled } from '@ant-design/icons'
import Message from '../../components/common/Message'
import FileItem from '../../components/FileItemComponent/FileItem'
import CheckLight from '../../components/image/CheckLight'
import CheckSuccessIcon from '../../components/image/CheckSuccessIcon'
import SkeletonWorkDetail from '../../components/Skeleton/SkeletonWorkDetail'
import { getExtensionFile } from '../../utils/common'
import { WORK_STATUS } from '../../utils/constants'
import ContentModal from '../../components/dialog/ContentModal'
import InformationModal from './InformationModal'
import CommentModal from './CommentModal'
import ListComment from './ListComment'
import { Menu, MenuItem, useTheme } from '@mui/material'
import PeopleTag from '../../components/PeopleTag'
import { findFollower, findHandler } from '../../utils/common'
import {
  AiOutlineComment,
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineFileText,
  AiOutlineHistory,
  AiOutlinePlusCircle,
  AiOutlineQuestionCircle,
  AiOutlineUser,
} from 'react-icons/ai'
import { Modal, Popover, message } from 'antd'
import utils from '../../utils'
import {
  MdOutlineComment,
  MdOutlineDone,
  MdOutlineRemoveDone,
} from 'react-icons/md'
import UpdateModal from './UpdateModal'
import { ACL_ACTION_TYPE, ASSIGNEE_TYPE, STATUS_DEFAULT } from '../../constants'
import AccessControlAction from '../../components/AccessControlAction/AccessControlAction'
import CreateModal from './CreateModal'
import PopupAddPerson from './PopupAddPerson'
import PopupAddPersonVote from './PopupAddPersonVote'
import { OpinionItem, UpdateVotePopover } from './DrawerWorkStyle'
import PopupElectronicReleaseForm from './PopupElectronicReleaseForm'
const WorkDetail = props => {
  const {
    workStore,
    selectPeopleStore,
    loadingAnimationStore,
    authenticationStore,
    voteStore,
  } = props
  const {
    getWorkDetail,
    workDetail,
    markImportantWork,
    updateStatusWork,
    getCommentWorkList,
    commentWorkList,
    deleteCommentWork,
    queryParams,
    workList,
  } = workStore
  const { clearSelectPeopleStore, clearSelected } = selectPeopleStore
  const { currentUser } = authenticationStore
  const { code, status } = workDetail
  const { voteDetail } = voteStore
  console.log(JSON.stringify(voteDetail))
  const [messages, setMessage] = useState('')
  const [openMessage, setOpenMessage] = useState(false)
  const [severity, setSeverity] = useState('')
  const createMessage = (messages, openMessage, severity) => {
    setMessage(messages)
    setOpenMessage(openMessage)
    setSeverity(severity)
  }
  const { workId } = useParams()
  const navigate = useNavigate()
  const [openContent, setOpenContent] = useState(false)
  const [openInfor, setOpenInfor] = useState(false)
  const [openCmt, setOpenCmt] = useState(false)
  const [openPopupAddPerson, setOpenPopupAddPerson] = useState(false)
  const [openPopupAddPersonVote, setOpenPopupAddPersonVote] = useState(false)
  const [openPopupElectronicRelease, setOpenPopupElectronicRelease] =
    useState(false)
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    title: null,
    to_date: null,
    from_date: null,
    status: null,
    permission: null,
  })
  const [deleteItem, setDeleteItem] = useState({
    open: false,
    id_comment: '',
  })

  const [workSelect, setWorkSelect] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingCmt, setLoadingCmt] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [openMore, setOpenMore] = useState(false)
  const [openCmtDel, setOpenCmtDel] = useState(false)

  const open = Boolean(anchorEl)
  const [check, setCheck] = useState(false)
  const [openCreCvp, setOpenCreCvp] = useState(false)

  useEffect(() => {
    ;(async () => {
      try {
        code && (await voteStore.getVoteDetail(code))
      } catch (error) {
        console.log(error)
        // message.error(error?.vi || 'Đã có lỗi xảy ra!')
      } finally {
      }
    })()
  }, [code])
  useEffect(() => {
    return () => {
      voteStore.clearStore()
    }
  }, [])

  const handleAgree = async userCode => {
    await voteStore.updateVote(userCode, { result: true })
    await voteStore.getVoteDetail(code)
    await fetchDetails()
  }
  const handleDisagree = async userCode => {
    await voteStore.updateVote(userCode, { result: false })
    await voteStore.getVoteDetail(code)
    await fetchDetails()
  }

  const handleOpen = () => {
    clearSelected()
    clearSelectPeopleStore()
    selectPeopleStore.clearSelectedByType(ASSIGNEE_TYPE.HANDLER)
    selectPeopleStore.clearSelectedByType(ASSIGNEE_TYPE.FOLLOWER)
    setOpenCreCvp(true)
  }
  const [openUp, setOpenUp] = useState(false)

  const fetchDetails = async () => {
    if (workId) {
      // handleOpenDrawerWork()
      const parentId = utils.getParameterByName('parent_id')
      loadingAnimationStore.setShowSpinInline(true)
      try {
        if (parentId) {
          await workStore.getListSubWork(parentId)
        }
        await workStore.getWorkDetail(workId)
      } catch (err) {
        navigate('/work')
        // handleCloseDrawerWork()
        // console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra')
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    }
  }
  const handleDeleteWork = async () => {
    const parentId = utils.getParameterByName('parent_id')
    try {
      await workStore.deleteWork(code)
      if (parentId) {
        await workStore.getListSubWork(parentId)
        await workStore.getWorkDetail(parentId)
        window.history.replaceState(null, null, `/works/view/${parentId}`)
      } else {
        const indexParentTarget = workList.findIndex(item => item.code === code)
        workList.splice(indexParentTarget, 1)
      }
      message.success('Xóa thành công')
    } catch (err) {
      // console.log(err)
    } finally {
      navigate(-1)
    }
  }

  const commentWorkListNotDeleted = commentWorkList?.filter(
    item => item.deleted !== true
  )
  const commentWorkListDeleted = commentWorkList?.filter(
    item => item.deleted === true
  )

  const onCommentSuccess = async () => {
    try {
      setLoadingCmt(true)
      await Promise.all([getCommentWorkList(workId)])
    } catch (err) {
      // console.log(err)
    } finally {
      setLoadingCmt(false)
    }
  }
  const { confirm } = Modal
  const showConfirmDeleteWork = () => {
    confirm({
      title: 'Bạn có muốn xóa công việc này không?',
      icon: (
        <AiOutlineQuestionCircle
          style={{ color: 'red', width: '30px', height: '30px' }}
        />
      ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteWork()
      },
    })
  }
  const getDetailWork = async () => {
    try {
      setLoading(true)
      await Promise.all([getWorkDetail(workId)])
    } catch (err) {
      // setMessage({ title: err.vi })
      // setIsOpen({ isOpen: true })
      createMessage(err.vi, true, 'error')
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    ;(async () => {
      await Promise.all([getDetailWork(), onCommentSuccess()])
      await fetchDetails()
    })()
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workId])

  const handleMarkImportantWork = async is_important => {
    try {
      await markImportantWork(workId, is_important)
      // setMessage({
      //   title: `Đánh dấu công việc ${
      //     is_important ? 'quan trọng' : 'Không quan trọng'
      //   }`,
      // })
      // setIsOpen({ isOpen: true })
      // setSeverity({ severity: 'success' })
      createMessage(
        `Đánh dấu công việc ${
          is_important ? 'quan trọng' : 'Không quan trọng'
        }`,
        true,
        'success'
      )
      await getWorkDetail(workId)
    } catch (err) {
      // setMessage({ title: err.vi })
      // setIsOpen({ isOpen: true })
      // setSeverity({ severity: 'error' })
      createMessage(err.vi, true, 'error')
    }
  }
  const handleUpdateStatus = async status => {
    try {
      await updateStatusWork(workId, status)
      await getWorkDetail(workId)
      // setMessage({
      //   title: `Đánh dấu công việc ${
      //     status === WORK_STATUS.COMPLETE ? 'hoàn thành' : 'chưa hoàn thành'
      //   }`,
      // })
      // setIsOpen({ isOpen: true })
      // setSeverity({ severity: 'success' })
      createMessage(
        `Đánh dấu công việc ${
          status === WORK_STATUS.COMPLETE ? 'hoàn thành' : 'chưa hoàn thành'
        }`,
        true,
        'success'
      )
    } catch (err) {
      // console.log(err.vi)
      // setMessage({ title: err.vi })
      // setIsOpen({ isOpen: true })
      // setSeverity({ severity: 'error' })
      createMessage(err.vi, true, 'error')
    }
  }

  const handleDeleteComment = async () => {
    setDeleteItem({ open: false, comment_id: '' })
    try {
      setLoading(true)
      await deleteCommentWork(workId, deleteItem.id_comment)
      await getCommentWorkList(workId)
      createMessage(`Xóa comment thành công`, true, 'success')
    } catch (err) {
      // setMessage({ title: err.vi })
      // setIsOpen({ isOpen: true })
      createMessage(err.vi, true, 'error')
    } finally {
      setLoading(false)
    }
  }
  const theme = useTheme()
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  let menu = (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      {openMore ? (
        <MenuItem
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}
          onClick={() => {
            setOpenMore(false)
            setOpenCmtDel(false)
            handleClose()
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Ẩn ý kiến đã xóa
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            setOpenMore(true)
            setOpenCmtDel(true)
            handleClose()
          }}
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Hiện ý kiến đã xóa
        </MenuItem>
      )}
    </Menu>
  )
  const handleOpenPopupEditPersonVote = () => {
    setOpenPopupAddPersonVote(true)
    selectPeopleStore.setAssigneePopupType(ASSIGNEE_TYPE.USER)
    selectPeopleStore.setSelectUserData(
      selectPeopleStore.convertSelectDataObj(voteDetail)
    )
  }
  const handleOpenPopupAddPersonVote = () => {
    setOpenPopupAddPersonVote(true)
    selectPeopleStore.setAssigneePopupType(ASSIGNEE_TYPE.USER)
    selectPeopleStore.setSelectUserData(
      selectPeopleStore.convertSelectDataObj([])
    )
  }
  return (
    <>
      {loading ? (
        <SkeletonWorkDetail />
      ) : (
        <>
          <div
            className="flex items-center p-[20px] gap-[22px] fixed w-full z-50"
            style={{
              background: theme.background.header,
              color: theme.color.text1,
            }}>
            <ArrowLeftCircle
              style={{ marginLeft: '10px' }}
              className="flex-shrink-0"
              onClick={() => {
                navigate(-1)
              }}
            />
            <span
              className="font-bold text-[28px] leading-[29px] "
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                width: '100%',
                lineHeight: '35px',
              }}>
              Công việc: {workDetail?.title}
            </span>
          </div>
          <div className={`px-5 py-[8px]mb-16`}>
            <div className="mb-28 pt-20">
              <div
                style={{
                  marginTop: '10px',
                  boxShadow:
                    'rgba(0, 0, 0, 0.15) 0px 10px 10px -10px, rgba(0, 0, 0, 0.15) 0px -10px 10px -10px',
                }}>
                <span
                  style={{
                    wordWrap: 'break-word',
                    lineHeight: '35px',
                  }}
                  className="mt-5 text-[26px] leading-[28px] text-labelForm">
                  {workDetail?.title}
                </span>
                <div className="flex">
                  <div className="mt-4 text-sm font-semibold leading-5 text-labelForm">
                    Trạng thái:
                  </div>
                  <div className="mt-4 leading-5 ml-2">
                    {workDetail?.status === WORK_STATUS.COMPLETE ? (
                      <p className="flex items-center gap-[6px]">
                        <CheckSuccessIcon />
                        <span className="text-sm font-normal leading-6 text-black">
                          Hoàn thành
                        </span>
                      </p>
                    ) : (
                      <p className="flex items-center gap-[6px]">
                        <CheckLight />
                        <span className="text-sm font-normal leading-6 text-black">
                          Chưa hoàn thành
                        </span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {workDetail.parent_id ? (
                <></>
              ) : (
                <div
                  style={{
                    // padding: '20px',
                    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 10px 10px -10px',
                  }}>
                  <div className="mt-5 flex items-center text-sm font-semibold leading-5 text-labelForm">
                    Công việc phụ:
                    {status !== STATUS_DEFAULT.COMPLETE && (
                      <AccessControlAction
                        aclActionType={
                          ACL_ACTION_TYPE.them_cong_viec_phu__WORK
                        }>
                        <AiOutlinePlusCircle
                          style={{
                            color: '#0075FF',
                            marginLeft: 7,
                            width: '20px',
                            height: '20px',
                          }}
                          onClick={() => handleOpen()}
                        />
                      </AccessControlAction>
                    )}
                  </div>
                  {workDetail?.subwork?.length > 0 ? (
                    workDetail?.subwork?.map(item => (
                      <div
                        onClick={() => {
                          navigate(`/work/view/${item.code}`)
                        }}
                        className="flex items-center gap-2 p-1 mt-2 bg-itemBg rounded-xl">
                        <div className="w-[34px] relative  after:w-[2px] after:h-[14px] after:bg-[#E0E0E0] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2">
                          {item.status === WORK_STATUS.COMPLETE ? (
                            <CheckSuccessIcon />
                          ) : (
                            <CheckLight />
                          )}
                        </div>
                        <SingleLineEllipsis>{item?.title}</SingleLineEllipsis>
                        <MoreHorizCircle
                          className="text-primary h-[20px] w-[20px] min-h-[20px] min-w-[20px]"
                          onClick={e => {
                            e.stopPropagation()
                            setOpenContent(true)
                            setWorkSelect(item)
                          }}
                        />
                      </div>
                    ))
                  ) : (
                    <EmptyText>Không có</EmptyText>
                  )}
                </div>
              )}
              <div
                style={{
                  marginTop: '10px ',
                  boxShadow: 'rgba(0, 0, 0, 0.15) 0px 10px 10px -10px',
                }}>
                <div className=" flex  gap-x-2 items-center  rounded-full mt-4 mb-[6px] text-sm font-semibold leading-5 text-labelForm">
                  <div>
                    <InfoEmpty />
                  </div>
                  <span>Thông tin</span>
                </div>
                <div className="mt-4 mb-[6px] text-sm font-semibold leading-5 text-labelForm">
                  Người xử lý:
                </div>
                <div className="flex flex-wrap gap-3">
                  {findHandler(workDetail?.assignees)?.length > 0 ? (
                    findHandler(workDetail?.assignees)?.map(item => (
                      <PeopleTag el={item} />
                    ))
                  ) : (
                    <EmptyText>Không có</EmptyText>
                  )}
                </div>
                <div className="mt-4 mb-[6px] text-sm font-semibold leading-5 text-labelForm">
                  Người theo dõi:
                </div>
                <div className="flex flex-wrap gap-3">
                  {findFollower(workDetail?.assignees)?.length > 0 ? (
                    findFollower(workDetail?.assignees)?.map(item => (
                      <PeopleTag el={item} />
                    ))
                  ) : (
                    <EmptyText>Không có</EmptyText>
                  )}
                </div>
                <div className="mt-4 text-sm font-semibold leading-5 text-labelForm">
                  Thời gian:
                </div>
                <div className="mt-2 text-sm font-normal leading-6 text-black">
                  Ngày bắt đầu:{' '}
                  {moment(workDetail?.start_date).format('DD/MM/YYYY')}{' '}
                </div>
                <div className="mt-2 text-sm font-normal leading-6 text-black">
                  Ngày kết thúc:{' '}
                  {workDetail?.due_date ? (
                    moment(workDetail.due_date).format('DD/MM/YYYY')
                  ) : (
                    <EmptyText>Không rõ</EmptyText>
                  )}{' '}
                </div>
              </div>
              <div className="mt-4 text-sm font-semibold leading-5 text-labelForm">
                Nội dung:
              </div>
              <div className="w-full overflow-hidden">
                {workDetail?.content ? (
                  <RichText text={workDetail?.content} />
                ) : (
                  <EmptyText>Không có</EmptyText>
                )}
              </div>
              {workDetail?.attachments?.length > 0 && (
                <>
                  <div className="mt-4 mb-2 text-sm font-semibold leading-5 text-labelForm">
                    Tài liệu đính kèm:
                  </div>
                  {workDetail?.attachments.map(file => (
                    <FileItem
                      file={file}
                      key={file.file_id}
                      file_id={file.file_id}
                      file_name={file.file_name}
                      file_type={getExtensionFile(file.file_name)}
                    />
                  ))}
                </>
              )}
              {voteStore?.voteDetail.length > 0 && (
                <>
                  <div
                    style={{
                      height: 0.5,
                      backgroundColor: '#f0f0f0',
                      marginBottom: 10,
                    }}
                  />
                  <dt>Ý kiến</dt>
                  <dd>
                    <div>
                      {voteStore?.voteDetail?.map(user =>
                        currentUser.username === user.assignee_code ? (
                          <Popover
                            content={
                              <UpdateVotePopover>
                                <div className="content-title">Gửi ý kiến</div>
                                <div className="content-body">
                                  <div onClick={() => handleAgree(user.code)}>
                                    <div>
                                      <span className="thumb-up">
                                        <LikeFilled />
                                      </span>
                                    </div>
                                    <div>Đồng ý</div>
                                  </div>
                                  <div
                                    onClick={() => handleDisagree(user.code)}>
                                    <div>
                                      <span className="thumb-down">
                                        <DislikeFilled />
                                      </span>
                                    </div>
                                    <div>Không đồng ý</div>
                                  </div>
                                </div>
                              </UpdateVotePopover>
                            }
                            title={false}
                            trigger="hover">
                            <OpinionItem>
                              {user.result === true ? (
                                <span className="vote-icon thumb-up">
                                  <LikeFilled />
                                  <div>Đồng ý</div>
                                </span>
                              ) : user.result === false ? (
                                <span className="vote-icon thumb-down">
                                  <DislikeFilled />
                                  <div>Ko đồng ý</div>
                                </span>
                              ) : (
                                <span className="vote-icon">
                                  <span className="empty-circle"></span>
                                </span>
                              )}
                              <span
                                style={{
                                  fontSize: 12,
                                  textTransform: 'capitalize',
                                }}>
                                {user.name_uppercase?.toLowerCase()}
                              </span>
                            </OpinionItem>
                          </Popover>
                        ) : (
                          <OpinionItem>
                            {user.result === true ? (
                              <span className="vote-icon thumb-up">
                                <LikeFilled />
                                <div>Đồng ý</div>
                              </span>
                            ) : user.result === false ? (
                              <span className="vote-icon thumb-down">
                                <DislikeFilled />
                                <div>Ko đồng ý</div>
                              </span>
                            ) : (
                              <span className="vote-icon">
                                <span className="empty-circle"></span>
                              </span>
                            )}

                            <span
                              style={{
                                fontSize: 12,
                                textTransform: 'capitalize',
                              }}>
                              {user.name_uppercase?.toLowerCase()}
                            </span>
                          </OpinionItem>
                        )
                      )}
                    </div>
                  </dd>
                </>
              )}
              <div>
                {commentWorkListDeleted?.length > 0 ? (
                  <>
                    <div className="mt-4 text-sm flex items-center">
                      <div className="font-semibold leading-5 text-labelForm">
                        Danh sách ý kiến
                      </div>
                      <MoreHorizCircle
                        className="text-primary ml-2"
                        onClick={handleClick}
                      />
                      {menu}
                    </div>
                    {openCmtDel ? (
                      <ListComment
                        loadingCmt={loadingCmt}
                        commentWorkList={commentWorkListDeleted}
                        setDeleteItem={setDeleteItem}
                      />
                    ) : (
                      ''
                    )}
                    <ListComment
                      loadingCmt={loadingCmt}
                      commentWorkList={commentWorkListNotDeleted}
                      setDeleteItem={setDeleteItem}
                    />
                  </>
                ) : (
                  <>
                    {commentWorkListNotDeleted?.length > 0 && (
                      <>
                        <div className="mt-4 text-sm flex items-center">
                          <div className="font-semibold leading-5 text-labelForm">
                            Danh sách ý kiến
                          </div>
                          <MoreHorizCircle
                            className="text-primary ml-2"
                            onClick={handleClick}
                          />
                          {menu}
                        </div>
                        {openCmtDel ? (
                          <ListComment
                            loadingCmt={loadingCmt}
                            commentWorkList={commentWorkListDeleted}
                            setDeleteItem={setDeleteItem}
                          />
                        ) : (
                          ''
                        )}
                        <ListComment
                          loadingCmt={loadingCmt}
                          commentWorkList={commentWorkListNotDeleted}
                          setDeleteItem={setDeleteItem}
                        />
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <ContentModal
        open={openContent}
        handleClose={() => {
          setOpenContent(false)
        }}
        content={workSelect?.content || workSelect?.title}
      />
      <InformationModal
        open={openInfor}
        handleClose={() => {
          setOpenInfor(false)
        }}
        workDetail={workDetail}
      />
      <CommentModal
        open={openCmt}
        handleClose={() => {
          setOpenCmt(false)
        }}
        workCode={workDetail.code}
        onCommentSuccess={onCommentSuccess}
      />
      <PopupAddPerson
        open={openPopupAddPerson}
        handleClose={() => {
          setOpenPopupAddPerson(false)
        }}
        workCode={workDetail.code}
      />
      <PopupAddPersonVote
        open={openPopupAddPersonVote}
        handleClose={() => {
          setOpenPopupAddPersonVote(false)
        }}
        workCode={workDetail.code}
      />
      <PopupElectronicReleaseForm
        isVisiblePopupElectronicRelease={openPopupElectronicRelease}
        handleCloseElectronicRelease={() => {
          setOpenPopupElectronicRelease(false)
        }}
        workCode={workDetail.code}
      />

      <footer
        style={{
          position: 'fixed',
          bottom: 0,
          backgroundColor: 'white',
          borderTopRightRadius: '10px',
          borderTopLeftRadius: '10px',
        }}
        className=" flex items-center justify-between px-5 w-full py-4 shadow-[0px_0px_8px_rgba(0,0,0,0.25)]">
        <div className="flex justify-between  w-full h-full">
          <div className="block text-center w-[70px]">
            <div
              className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => setOpenCmt(true)}>
              <AiOutlineComment style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Đăng ý kiến</div>
          </div>
          <div className="block text-center w-[70px]">
            <div
              className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => setOpenPopupAddPerson(true)}>
              <AiOutlineUser style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Thêm người</div>
          </div>
          <div className="block text-center w-[70px]">
            <div
              className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => {
                voteStore?.voteDetail?.length > 0
                  ? handleOpenPopupEditPersonVote()
                  : handleOpenPopupAddPersonVote()
              }}>
              <MdOutlineComment style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Lấy ý kiến</div>
          </div>
          <div className="block text-center w-[70px]">
            <div
              className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => setOpenPopupElectronicRelease(true)}>
              <AiOutlineFileText style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Phát hành</div>
          </div>
          {/* <div className="block text-center w-[70px]">
            <div
              className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => setOpenPopupAddPersonVote(true)}>
              <AiOutlineHistory style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Lịch sử</div>
          </div> */}
          <div className="block text-center w-[70px]">
            <div
              onClick={() => setOpenUp(true)}
              className="hover:bg-cyan-400 inline-block
              bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px]
              text-center px-[8px] rounded-full text-sm font-medium">
              <AiOutlineEdit style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Sửa cv</div>
          </div>
          <div className="block text-center w-[70px]">
            <div
              className={`bg-[rgba(0,115,199,0.07);] py-[8px] inline-block ${
                workDetail?.status === WORK_STATUS.COMPLETE
                  ? 'hover:bg-cyan-400 hover:text-white py-[8px]hover:text-white'
                  : 'text-checkedSuccess hover:bg-cyan-400 py-[8px]hover:text-white'
              }   text-black text-center px-[8px] rounded-full text-sm  font-medium`}
              onClick={() => {
                handleUpdateStatus(
                  workDetail?.status === WORK_STATUS.COMPLETE
                    ? WORK_STATUS.PENDING
                    : WORK_STATUS.COMPLETE
                )
              }}>
              {workDetail?.status === WORK_STATUS.COMPLETE ? (
                <MdOutlineRemoveDone
                  style={{ width: '20px', height: '20px' }}
                />
              ) : (
                <MdOutlineDone style={{ width: '20px', height: '20px' }} />
              )}
            </div>
            <div style={{ fontSize: '11px' }}>Trạng thái</div>
          </div>
          <div className="block text-center w-[70px]">
            <div
              className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-red-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => showConfirmDeleteWork()}>
              <AiOutlineDelete style={{ width: '20px', height: '20px' }} />
            </div>
            <div style={{ fontSize: '11px' }}>Xóa cv</div>
          </div>

          <div className="block text-center w-[70px]">
            <div className="hover:bg-cyan-400 inline-block text-[#F8F8F8] bg-[rgba(0,115,199,0.07);] py-[8px] text-center px-[8px] rounded-full text-sm  font-medium">
              <Star
                onClick={() => handleMarkImportantWork(!workDetail?.important)}
                color={`${workDetail?.important ? '#FFC700' : '#A2A2A2'}`}
                height={20}
                width={20}
                fill={`${workDetail?.important ? '#FFC700' : 'white'}`}
              />
            </div>
            <div style={{ fontSize: '11px' }}>Cv ưu tiên</div>
          </div>
        </div>
      </footer>
      <AlertDialog
        open={deleteItem.open}
        handleClose={() => setDeleteItem({ open: false, comment_id: '' })}
        handleDelete={handleDeleteComment}
      />
      {/* <Message
        messages={messages.title}
        openMessage={isOpen.isOpen}
        severity={severity.severity}
        closeMessage={() => {
          setIsOpen({ isOpen: false })
        }}
      /> */}
      <Message
        message={messages}
        openMessage={openMessage}
        severity={severity}
        closeMessage={() => {
          setOpenMessage(false)
        }}
      />
      <UpdateModal
        createMessage={createMessage}
        workDetail={workDetail}
        open={openUp}
        handleClose={() => {
          setOpenUp(false)
        }}
      />
      <CreateModal
        createMessage={createMessage}
        params={setFilter}
        code={code}
        open={openCreCvp}
        handleClose={() => {
          setOpenCreCvp(false)
        }}
        check={check}
        setCheck={setCheck}
      />
    </>
  )
}

export default memo(
  inject(
    'workStore',
    'selectPeopleStore',
    'loadingAnimationStore',
    'voteStore',
    'authenticationStore'
  )(observer(WorkDetail))
)
